import { Container, Typography, Button, Box, GlobalStyles } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

function NotFound() {
  const navigate = useNavigate();

  return (
    <>
      <GlobalStyles 
        styles={{ 
          'body': { 
            overflow: 'hidden',
            margin: 0,
            height: '100vh'
          } 
        }} 
      />
      <Box 
        sx={{ 
          height: '100vh',
          overflow: 'hidden',
          bgcolor: 'background.default',
          pt: { xs: 2, sm: 4 }
        }}
      >
        <Container 
          sx={{ 
            height: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center'
          }}
        >
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              maxWidth: '600px',
              mt: { xs: 0, sm: 2 }
            }}
          >
            <Typography 
              variant="h1" 
              sx={{
                fontSize: { xs: '6rem', sm: '8rem', md: '10rem' },
                fontWeight: 'bold',
                color: 'primary.main',
                mb: 1,
                lineHeight: 0.8
              }}
            >
              404
            </Typography>

            <Typography 
              variant="h4" 
              sx={{ 
                mb: 2,
                color: 'text.secondary',
                fontWeight: 'medium',
                fontSize: { xs: '1.5rem', sm: '2rem' }
              }}
            >
              Oups ! Cette page n'existe pas
            </Typography>

            <Typography 
              variant="body1" 
              sx={{ 
                mb: 3,
                color: 'text.secondary'
              }}
            >
              La page que vous recherchez semble avoir été déplacée, supprimée ou n'a jamais existé.
            </Typography>

            <Button 
              variant="contained" 
              onClick={() => navigate('/')}
              startIcon={<HomeIcon />}
              sx={{ 
                py: 1.5,
                px: 4,
                borderRadius: 2,
                fontSize: '1.1rem',
                textTransform: 'none'
              }}
            >
              Retour à l'accueil
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default NotFound; 